import { ExportColumn } from '../../../../interfaces/ExportColumn';

const baseColumns: ExportColumn[] = [
  {
    key: 'hostingEntityName',
    header: 'Hosting Entity Name',
    type: 'text',
  },
  {
    key: 'hostingAssetServer',
    header: 'Hosting Asset / Server',
    type: 'text',
  },
  {
    key: 'type',
    header: 'Type',
    type: 'text',
  },
  {
    key: 'itOwner',
    header: 'IT Owner (Name & Email)',
    type: 'text',
  },
  {
    key: 'businessOwner',
    header: 'Business Owner (Name & Email)',
    type: 'text',
  },
  {
    key: 'address',
    header: 'Address',
    type: 'text',
  },
  {
    key: 'rebuildTimeMonths',
    header: 'Rebuild Time (Months)',
    type: 'number',
  },
  {
    key: 'drInPlace',
    header: 'DR in Place',
    type: 'boolean',
  },
  {
    key: 'tier.name',
    header: 'DR Tier',
    type: 'text',
  },
];

export { baseColumns };
